// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3E_Jw","info":"PatientInfo_info__AYk4l"};